import * as React from 'react';

import classnames from 'classnames';

import styles from './checkbox-button.module.css';

type Props = {
    checked: boolean;
    onChange: (newCheckedState: boolean, e: React.ChangeEvent<any>) => void;
    label: string;
    size: 'small' | 'normal';
    disabled?: boolean;
    getButtonRef?: (arg1?: HTMLElement | null | undefined) => void;
    noPadding?: boolean;
    icon?: React.ComponentType<any>;
};

/**
A stylized checkbox input that tries to mimic a standard "nutshell button" with the "secondary" styling.
Should only be used for boolean fields next to other filter capsules,
such as the graduated filters on the entity list.
 */
export class CheckboxButton extends React.PureComponent<Props> {
    static defaultProps = {
        size: 'normal',
    };

    render() {
        const Icon = this.props.icon;
        const styleName = classnames(
            this.props.checked ? styles.checked : styles.unchecked,
            styles[this.props.size],
            {
                [styles.disabled]: this.props.disabled,
                [styles['no-padding']]: this.props.noPadding,
            }
        );

        return (
            <label ref={this.props.getButtonRef} className={styleName}>
                <div className='flex align-center'>
                    <span className={styles['checkbox-container']}>
                        <input
                            checked={this.props.checked}
                            disabled={this.props.disabled}
                            type='checkbox'
                            onChange={this.handleChange}
                        />
                    </span>
                    <span className={styles.label}>
                        <span>{this.props.label}</span>
                        {Icon ? <Icon size={14} alignCenter={true} /> : undefined}
                    </span>
                </div>
            </label>
        );
    }

    handleChange = (e: React.ChangeEvent<any>) => {
        this.props.onChange(e.target.checked, e);
    };
}
